import React from "react";
import NavBar from "../components/navbar/navBar";
import Footer from "../components/footer";
import AllCertificatesFetcher from "../components/fetchers/allCertificatesFetchers";
import { Typography, Box } from "@mui/material";
import { useContext } from "react";
import { themeContext } from "../context";

const CertificatesPage = () => {

  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  
  return (
    <>
      <NavBar />
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4, mb: 4, flexDirection: 'column', alignItems: 'center' }}>
        <Typography
          sx={{
            color: darkMode ? "white" : "var(--black)",
            fontSize: "2.5rem",
            fontWeight: "bold",
          }}
        >
          Completed
        </Typography>
        <Typography
          sx={{ color: "var(--orange)", fontSize: "3rem", fontWeight: "bold" }}
        >
          Certifications
        </Typography>
      </Box>
      <AllCertificatesFetcher />
      <Footer />
    </>
  );
};

export default CertificatesPage;
